import db from '../../versa/db.js';
import { storageArmCodeFromProduct, storageArmCodeFromLabel, storageArmLabel } from '../utils/storage-arm-type.js';
import { paintOutputOrderStorageArmBanner } from '../forms/output-orders-storage-arm.js';

/** Observa product_id da linha e preenche Arm. (Climatizado / Refrigerado). #MT-3902248 */
export default function (..._args)
{
	return {
		async actions(_ev, _publisher, product_id)
		{
			const node = document.querySelector(this.selector);
			const formRoot = node?.closest?.('#order') || document.querySelector('#order');
			const company_id = this.locate('company_id')?.getValue?.();
			const pid = product_id != null && product_id !== '' ? Number(product_id) : NaN;
			if (!company_id || !Number.isInteger(pid) || pid <= 0)
			{
				this.setValue?.('');
				this.refresh?.();
				paintOutputOrderStorageArmBanner(formRoot);
				return;
			}
			let product = null;
			try
			{
				product = await db.get('products', [company_id, pid]);
			}
			catch (_e)
			{
				product = null;
			}
			const label = storageArmLabel(storageArmCodeFromProduct(product));
			if (label)
				this.setValue(label);
			else if (!storageArmCodeFromLabel(this.getValue?.()))
				this.setValue('');
			this.refresh?.();
			paintOutputOrderStorageArmBanner(formRoot);
		},
	};
}
